import { Type } from "class-transformer";
import { Project } from "./Project";
import { ProjectCustomFieldDefinition } from "./ProjectCustomFieldDefinition";

export class ProjectField {
    fieldDefinitionId = 0;
    @Type(() => ProjectCustomFieldDefinition)
    fieldDefinition: ProjectCustomFieldDefinition;
    value: string;
    projectId = 0;
    @Type(() => Project)
    project: Project;
    id = 0;
}
